import React, { useEffect, useState } from 'react';
import Card from "react-bootstrap/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import swal from 'sweetalert';
import { approveDataRegisterLog, getGetDataRegisterLogs, returnDataRegisterLog } from '../../ApiServices/apiHandler';
import { toast } from 'react-toastify';
import notificationCss from '../../../../myfin_v2/css/notifications.module.css';
import ReturnDataRegisterLogModal from './ReturnDataRegisterLogModal';

const DataRegisterPanel = ({
    label,
    responsibilities
}) => {

    const [logs, setLogs] = useState([]);
    const [returnLogModal, setReturnLogModal] = useState({
        isOpen: false,
        returnText: "",
        title:"",
        registerId:""
    });

    useEffect(() => {
        getGetDataRegisterLogs(label.value).then(response => {
            setLogs(response.data?.logs);
        }).catch(error => {
            swal("Error", error.response?.data?.error || "Getting Data Register Logs Failed!" , "error");
        })
    }, []);

    const ApproveDataRegisterLog = (registerId) => {
        approveDataRegisterLog(registerId).then(response => {
            toast.success(`${label.label} register approved successfully.`);
        }).catch(error => {
            swal("Error", error.response?.data?.error || `Approved ${label.value} Register Logs Failed!` , "error");
        })
    }

    const ReturnDataRegisterLog = () => {
        returnDataRegisterLog({
            returnReason: returnLogModal.returnText
        },
        returnLogModal.registerId
        ).then(response => {
            toast.success(`${label.label} register returned successfully.`);
            setReturnLogModal(prev => ({...prev, isOpen: false, returnText: "", registerId: "", title:"" }))
        }).catch(error => {
            swal("Error", error.response?.data?.error || `Return ${label.value} Register Logs Failed!` , "error");
            setReturnLogModal(prev => ({...prev, isOpen: true, returnText: "", registerId: "", title:"" }))
        })
    }

    const getNotificationReturnUrl = () => {
        if (typeof window === "undefined") {
            return "";
        }

        const notificationUrl = new URL("/notification", window.location.origin);
        notificationUrl.searchParams.set("tab", "data_set_related_approvals");
        notificationUrl.searchParams.set("sec", label.value.replace(/ /g, "_"));

        return notificationUrl.toString();
    };

    const getViewRedirectUrl = (viewUrl) => {
        if (!viewUrl || typeof window === "undefined") {
            return viewUrl || "#";
        }

        try {
            const redirectUrl = new URL(viewUrl, window.location.origin);
            const returnUrl = getNotificationReturnUrl();

            redirectUrl.searchParams.set("mf_return_to", returnUrl);
            redirectUrl.searchParams.set("mf_return_source", "notification");
            redirectUrl.searchParams.set("mf_return_tab", "data_set_related_approvals");
            redirectUrl.searchParams.set("mf_return_section", label.value.replace(/ /g, "_"));

            return redirectUrl.toString();
        } catch (error) {
            return viewUrl;
        }
    };

    const extraColumns = label.value === "lease"
        ? [
            { key: "leaseName", label: "Lease Name" },
            { key: "leaseId", label: "Lease ID" }
        ]
        : label.value === "lease register"
            ? [
                { key: "leaseRegisterName", label: "Lease Register Name" }
            ]
            : [];

    const getExtraColumnValue = (log, columnKey) => {
        if (columnKey === "leaseName") {
            return log?.leaseData?.name || "-";
        }

        if (columnKey === "leaseId") {
            return log?.leaseData?.leaseID || "-";
        }

        if (columnKey === "leaseRegisterName") {
            return log?.leaseRegisterData?.name || "-";
        }

        return "-";
    };

    const isLeaseTable = label.value === "lease";
    const isLeaseRegisterTable = label.value === "lease register";
    const tableMinWidth = isLeaseTable ? "1060px" : isLeaseRegisterTable ? "980px" : "860px";

    const columnWidths = isLeaseTable
        ? ["23%", "16%", "7%", "11%", "12%", "14%", "17%"]
        : isLeaseRegisterTable
            ? ["23%", "21%", "13%", "13%", "14%", "16%"]
            : ["34%", "18%", "18%", "14%", "16%"];

    return (
        <>
        <div className={notificationCss.tablePanelContent}>
            <div className={notificationCss.tableScrollWrapper}>
                <table
                    className={notificationCss.dataTable}
                    style={{ minWidth: tableMinWidth }}
                >
                    <colgroup>
                        {columnWidths.map((width, index) => (
                            <col key={`${label.value}-column-${index}`} style={{ width }} />
                        ))}
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Title</th>
                            {extraColumns.map((column) => (
                                <th key={column.key}>{column.label}</th>
                            ))}
                            <th>Approver</th>
                            <th>Preparer</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            logs.length > 0 ? logs.map((log, index) => (
                                <tr key={index}>
                                    <td
                                        title={log?.title}
                                        style={{
                                            textTransform: "capitalize"
                                        }}
                                    >
                                        {log?.title}
                                    </td>
                                    {extraColumns.map((column) => (
                                        <td
                                            key={`${log?._id || index}-${column.key}`}
                                            title={getExtraColumnValue(log, column.key)}
                                        >
                                            {getExtraColumnValue(log, column.key)}
                                        </td>
                                    ))}
                                    <td title={log?.approverData?.name}>{log?.approverData?.name}</td>
                                    <td title={log?.preparerData?.name}>{log?.preparerData?.name}</td>
                                    <td align='center'>
                                        <span
                                            className={log?.status === "approved" ? notificationCss.approvedBadge
                                                : log?.status === "returned" ? notificationCss.returnBadge : notificationCss.defaultBadge
                                            }
                                        >
                                            {log?.status}
                                        </span>
                                    </td>
                                    <td align='center'>
                                        <div className={notificationCss.tableActionGroup}>
                                            <a href={getViewRedirectUrl(log?.url)} className={notificationCss.viewBtn} >View</a>
                                            {
                                                responsibilities === "approver" && (
                                                    <>
                                                        <button
                                                            className='border-0 bg-color-inherit text-success font-size-12'
                                                            onClick={() => ApproveDataRegisterLog(log._id)}
                                                        >
                                                            Approve
                                                        </button>
                                                        <button
                                                            className='border-0 bg-color-inherit text-danger font-size-12'
                                                            onClick={() => setReturnLogModal(prev => ({ ...prev,
                                                                isOpen: true,
                                                                title: log?.title,
                                                                registerId: log._id
                                                            }))}
                                                        >
                                                            Return
                                                        </button>
                                                    </>
                                                )
                                            }
                                        </div>
                                    </td>
                                </tr>
                            )) : <tr> <td colSpan={5 + extraColumns.length} align='center' className='text-secondary custom-font-500'> No Data Found </td> </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
        {returnLogModal.isOpen && (
            <ReturnDataRegisterLogModal 
                returnLogModal={returnLogModal}
                setReturnLogModal={setReturnLogModal}
                OnClick={ReturnDataRegisterLog}
            />
        )}
        {/* <Card>
            <CardContent>
                <Box>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className='custom-font-500'>Title</TableCell>
                                    <TableCell className='custom-font-500'>Approver</TableCell>
                                    <TableCell className='custom-font-500'>Preparer</TableCell>
                                    <TableCell className='custom-font-500 text-center'>Status</TableCell>
                                    <TableCell className='custom-font-500 text-center'>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    logs.length > 0 ? logs.map((log, index) => (
                                        <TableRow key={index}>
                                            <TableCell className='text-secondary'> {log?.title} </TableCell>
                                            <TableCell className='text-secondary'>{log?.approverData?.email}</TableCell>
                                            <TableCell className='text-secondary'>{log?.preparerData?.email}</TableCell>
                                            <TableCell align='center'>
                                                <span 
                                                    class={log?.status === "approved" ? "badge badge-success py-1 px-2" 
                                                        : log?.status === "returned" ? "badge badge-danger py-1 px-2" : "badge badge-primary py-1 px-2"
                                                    }
                                                >
                                                    {log?.status}
                                                </span>
                                            </TableCell>
                                            <TableCell align='center'>
                                                <a href={log?.url} className='font-size-12' > View </a>
                                                {
                                                    responsibilities === "approver" && (
                                                        <>
                                                            <button 
                                                                className='ml-3 border-0 bg-color-inherit text-success font-size-12'
                                                                onClick={() => ApproveDataRegisterLog(log._id)}
                                                            >
                                                                Approve
                                                            </button>
                                                            <button 
                                                                className='ml-3 border-0 bg-color-inherit text-danger font-size-12'
                                                                onClick={() => setReturnLogModal(prev => ({...prev, 
                                                                    isOpen:true,
                                                                    title: log?.title,
                                                                    registerId: log._id
                                                                }))}
                                                            >
                                                                Return
                                                            </button>
                                                        </>
                                                    )
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )) : <TableRow> <TableCell colSpan={4} align='center' className='text-secondary custom-font-500'> No Data Found </TableCell> </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </CardContent>
            <ReturnDataRegisterLogModal 
                returnLogModal={returnLogModal}
                setReturnLogModal={setReturnLogModal}
                OnClick={ReturnDataRegisterLog}
            />
        </Card> */}
        </>
    )
}

export default DataRegisterPanel;